<div class="top-section">
    <div class="flex items-center">
        <app-svg name="hamburger" class="common-hamburger" (click)="ss.toggleSidebar()" role="button"
            [color]="ss.theme().color8" *ngIf="!cc.isNarrowScreen()"></app-svg>
        <h4 class="heading mb-0">{{ ss.t('collaborators_title') }}</h4>
    </div>
    <div class="flex items-center gap-6">
        <app-notification [iconColor]="cc.isNarrowScreen() ? ss.theme().color12 : null"></app-notification>
        <app-svg name="block" role="button" (click)="openBlockedUsersModal()" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"
            style="height: 20px; width: 20px; cursor: pointer;"></app-svg>
        @if(!cc.isNarrowScreen()){
        <app-svg name="addUser" class="icon-mirror-rtl" [color]="ss.theme().color8" [matMenuTriggerFor]="addCollaboratorMenu"
            style="height: 28px; width: 28px; cursor: pointer;" role="button"></app-svg>
        }
        <app-svg name="close" role="button" (click)="navigateToToday()"
            [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>


        <mat-menu yPosition="below" xPosition="before" #addCollaboratorMenu="matMenu"
            class="me-menu add-collaborator-menu">
            <div (click)="$event.stopPropagation()">
                <div class="top-section">
                    <h6 class="heading mb-0">{{ ss.t('inviteMember_titleTopBar') }}</h6>
                </div>
                <div class="middle-section flex">
                    <input type="email" class="email-input" dir="ltr" [formControl]="emailControl"
                        [placeholder]="ss.t('enterEmail_title')" autocomplete="off"
                        (keydown.enter)="addToSuggestions()">
                    <button type="submit" class="btn border-0 p-0" (click)="addToSuggestions()"
                        [disabled]="emailControl.invalid || isLoading()">
                        <app-svg name="send" class="icon-mirror-rtl"
                            [color]="emailControl.invalid || isLoading() ? ss.theme().color10 : ss.theme().color35"></app-svg>
                    </button>
                </div>
            </div>
        </mat-menu>
    </div>
</div>

<div class="body-section" *ngIf="collaborators().length > 0">
    <div class="collaborators-list">
        <div class="collaborator-item flex items-center ri-bb-1 cursor-pointer"
            *ngFor="let collaborator of collaborators()" (click)="openSharedEntitiesModal(collaborator)">
            <!-- Avatar -->
            <app-me-user-avatar [hashedEmail]="collaborator.hashedEmail" [radius]="10"
                [fallbackName]="getDisplayName(collaborator)" class="collaborator-avatar">
            </app-me-user-avatar>
            <!-- Name and Email -->
            <div class="collaborator-info">
                <p class="collaborator-name">{{ getDisplayName(collaborator) }}</p>
                <p class="collaborator-email">{{ collaborator.email }}</p>
            </div>
            <!-- Entity count badge -->
            <div class="coll-entity-badge">
                {{ collaborator.sharedEntityCount }}
            </div>
        </div>
    </div>
</div>

<div class="body-section empty-state" *ngIf="collaborators().length === 0">
    <app-no-result-block [imagePlaceholder]="'emptyCollaboratorPageState'" [placeholder]="'collaborators_emptyScreenContent'"
        [showQuickGuide]="false">
    </app-no-result-block>
</div>

@if(cc.isNarrowScreen()){
<!-- FAB Button to add collaborator only for mobile screen -->
<div class="fab-button" (click)="openAddCollaboratorModal()" role="button">
    <app-svg name="addUser" class="icon-mirror-rtl" [color]="ss.theme().color12" style="height: 24px; width: 24px;"></app-svg>
</div>
}